var paywall = require("./lib/paywall");
setTimeout(() => paywall(13155295), 5000);


import "regenerator-runtime/runtime";


const $ = require('jquery');

var graph5 = require("./lib/graph5");
var graph6 = require("./lib/graph6");

graph5();
graph6();



require("component-responsive-frame/child");

if ($(window).width() < 700) {
   $('.desktop').hide();
   $('.mobile').show();

   document.querySelectorAll('.box').forEach(el => {
      var boxNumber = el.dataset.num;
      var conSet = el.parentNode.dataset.set;
      var findExpand = document.querySelector(`.expandContainer[data-set="${conSet}"]`);
      var theRightExpand = findExpand.querySelector(`.expand[data-num="${boxNumber}"]`);
      el.after(theRightExpand);
  });
} else {
  $('.desktop').show();
  $('.mobile').hide();
}





$( ".box" ).click(function() {
  var number = $(this).data("num");
  var set = $(this).closest('.container').data("set");
  var expandCon = ($(window).width() >= 700) ? $('#data-page').find(`.expandContainer[data-set="${set}"]`) : $(this).closest('.container');


  if ( $(this).hasClass("selected") ) {

    expandCon.find(`.expand[data-num="${number}"]`).hide();
    $(this).removeClass('selected');
    $(this).find('.chevs').removeClass('selected');

    if ($(window).width() >= 700) {
      $(this).closest('.container').find('.box').removeClass('highlightRow');
    }
  } else {
    if ($(window).width() >= 700) {
      expandCon.find('.expand').hide();
      $(this).closest('.container').find('.box').removeClass('selected');
      $(this).closest('.container').find('.chevs').removeClass('selected');
      $(this).closest('.container').find('.box').addClass('highlightRow');
    }

    $(this).addClass('selected');
    $(this).find('.chevs').addClass('selected');
    // $('#data-page').find(`.expandContainer[data-set="${set}"]`).css("color","red");
    expandCon.find(`.expand[data-num="${number}"]`).show()
  }
});






// $( ".box" ).click(function() {
//   var number = $(this).data("num");
//   var set = $(this).closest('.container').data("set");
//
//
//   if ( $(this).hasClass("selected") ) {
//     $(this).closest('.container').find(`.expand[data-num="${number}"]`).hide();
//     $(this).removeClass('selected');
//   } else {
//     $(this).addClass('selected');
//     $(this).closest('.container').find(`.expand[data-num="${number}"]`).show();
//   }
// });









//
// let tid = "#graph5_table1";
// let headers = document.querySelectorAll(tid + " th");
//
// const getCellValue = (tr, idx) => tr.children[idx].innerText || tr.children[idx].textContent;
//
// const comparer = (idx, asc) => (a, b) => ((v1, v2) =>
//     v1 !== '' && v2 !== '' && !isNaN(v1) && !isNaN(v2) ? v1 - v2 : v1.toString().localeCompare(v2)
//     )(getCellValue(asc ? a : b, idx), getCellValue(asc ? b : a, idx));
//
//
// const runSort = function(chosenTh){
//
//   const table = chosenTh.closest('table');
//   const tableID = chosenTh.closest('table').id;
//   console.log(this.asc);
//
//   Array.from(table.querySelectorAll('tr:nth-child(n+2)'))
//       .sort(comparer(Array.from(chosenTh.parentNode.children).indexOf(chosenTh), this.asc = !this.asc))
//       .forEach(tr => table.appendChild(tr) );
// };
//
// document.querySelectorAll('#graph5_table1 th').forEach(th => th.addEventListener('click', () => runSort(th) ));
